<template>
  <el-dialog
    title="Edit Field Labels"
    :visible.sync="dialogVisible"
    width="70%"
    top="8vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <div
      style="display: flex; justify-content: flex-end; gap: 8px; margin-bottom: 10px"
    >
      <el-button size="mini" @click="$emit('set-all-required', true)"
        >Select All Required</el-button
      >
      <el-button size="mini" @click="$emit('set-all-required', false)"
        >Deselect All Required</el-button
      >
    </div>
    <el-table :data="rows" border empty-text="No Data" max-height="420">
      <el-table-column label="Page No." width="90" align="center">
        <template slot-scope="scope">{{ scope.row.pageNo }}</template>
      </el-table-column>
      <el-table-column label="Type" width="140" prop="type" />
      <el-table-column label="Filled By" min-width="140" prop="filledBy" />
      <el-table-column label="New Field Label" min-width="200">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.newLabel"
            placeholder="Enter label"
            size="small"
          />
        </template>
      </el-table-column>
      <el-table-column label="Existing Key" min-width="180" prop="existingKey" />
      <el-table-column label="Required" width="100" align="center">
        <template slot-scope="scope">
          <el-checkbox
            v-if="canMarkFieldRequired({ type: scope.row.type })"
            v-model="scope.row.required"
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">Close</el-button>
      <el-button type="primary" @click="$emit('save')">Save</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "EditFieldLabelsDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Array,
      default: () => [],
    },
    canMarkFieldRequired: {
      type: Function,
      required: true,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
};
</script>
